import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/logo";
import { Clock, LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export default function PendingReview() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/auth", { replace: true });
      }
    };
    checkSession();
  }, [navigate]);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/auth", { replace: true });
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-muted to-muted/80 p-6 dark:from-background dark:to-muted">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <Logo className="h-10" />
        </div>
        <div className="rounded-2xl border border-border bg-card p-8 text-center shadow-lg">
          <div className="mx-auto mb-6 flex size-16 items-center justify-center rounded-full bg-warning/10 dark:bg-amber-900/30">
            <Clock className="size-8 text-warning dark:text-warning" />
          </div>
          <h1 className="mb-2 text-xl font-semibold text-foreground">
            Account Under Review
          </h1>
          <p className="mb-6 text-muted-foreground">
            Thank you for signing up! We're reviewing your account and will notify you as soon as you're approved. This usually takes 1–2 business days.
          </p>
          <p className="mb-8 text-sm text-muted-foreground">
            Questions? Contact us at{" "}
            <a href="mailto:support@holescale.com" className="text-primary hover:underline">
              support@holescale.com
            </a>
          </p>
          <Button
            variant="outline"
            onClick={handleSignOut}
            className="w-full"
          >
            <LogOut className="mr-2 size-4" />
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
}
